import React, { useState } from "react";
import {
  FaTh,
  FaBars,
  FaUserAlt,
  FaRegChartBar,
  FaCommentAlt,
  FaShoppingBag,
  FaShoppingCart,
  FaThList,
  FaPlus,
  FaPlusCircle,
  FaUsers,
} from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { AiFillDollarCircle } from "react-icons/ai";
import { CgMediaLive } from "react-icons/cg";
import { NavLink } from "react-router-dom";

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const menuItem = [
    {
      path: "/",
      name: "Dashboard",
      icon: <FaTh />,
    },
    {
      path: "/users",
      name: "Admin",
      icon: <FaUserAlt />,
    },
    {
      path: "/customers",
      name: "Users",
      icon: <FaUsers />,
    },
    {
      path: "/webusers",
      name: "Web Users",
      icon: <FaUsers />,
    },
    {
      path: "/childwebusers",
      name: "ChildWeb Users",
      icon: <FaUsers />,
    },
    {
      path: "/messageapp",
      name: "Message app",
      icon: <FaShoppingBag />,
    },
    {
      path: "/display-flags",
      name: "List Flags",
      icon: <CgMediaLive />,
    },
     {
      path: "/display-reader",
      name: "List Reader",
      icon: <CgMediaLive />,
    },
     {
      path: "/display-places",
      name: "List Places",
      icon: <CgMediaLive />,
    },
    {
      path: "/display-youtube",
      name: "List Youtubes",
      icon: <CgMediaLive />,
    },
    {
      path: "/add-youtube",
      name: "Add Youtubes",
      icon: <CgMediaLive />,
    },
    {
      path: "/addbook",
      name: "Add Book",
      icon: <FaShoppingBag />,
    },
    {
      path: "/displaybooks",
      name: "List Books",
      icon: <CgMediaLive />,
    },
    {
      path: "/generalchurchhistory",
      name: "General Church History",
      icon: <CgMediaLive />,
    },
    {
      path: "/comparison",
      name: "Comparison",
      icon: <CgMediaLive />,
    },
    {
      path: "/doctrines",
      name: "Doctrines",
      icon: <CgMediaLive />,
    },
    {
      path: "/religions",
      name: "Religions",
      icon: <CgMediaLive />,
    },
    {
      path: "/timeline",
      name: "Timeline",
      icon: <CgMediaLive />,
    },
    {
      path: "/apologetics",
      name: "Apologetics",
      icon: <CgMediaLive />,
    },
    {
      path: "/addbiblesurvey",
      name: "Add Bible Survey",
      icon: <FaShoppingBag />,
    },
    {
      path: "/displaybiblesurveys",
      name: "List Bible Surveys",
      icon: <CgMediaLive />,
    },
    {
      path: "/generatebiblesurvey",
      name: "Generate Bible Surveys",
      icon: <CgMediaLive />,
    },
    {
      path: "/addcategory",
      name: "Add Category",
      icon: <FaShoppingBag />,
    },
    {
      path: "/displaydictionary",
      name: "Display Dictionary",
      icon: <FaShoppingBag />,
    },
    {
      path: "/adddictionary",
      name: "Add Dictionary",
      icon: <FaShoppingBag />,
    },
    {
      path: "/DisplayExplanationsEn",
      name: "Display En Explanations ",
      icon: <FaShoppingBag />,
    },
    {
      path: "/addexplanationEn",
      name: "Add En Explanations",
      icon: <FaShoppingBag />,
    },

    {
      path: "/displayexplanations",
      name: "Display Explanations",
      icon: <FaShoppingBag />,
    },
    {
      path: "/addexplanation",
      name: "Add Explanations",
      icon: <FaShoppingBag />,
    },

    {
      path: "/displaycategory",
      name: "List Category",
      icon: <CgMediaLive />,
    },

    {
      path: "/addcuisine",
      name: "Add Cuisne",
      icon: <FaShoppingBag />,
    },
    {
      path: "/displaycuisine",
      name: "List Cuisine",
      icon: <CgMediaLive />,
    },

    {
      path: "/addnewrecipes",
      name: "Add Recipes",
      icon: <FaShoppingBag />,
    },
    {
      path: "/listsnewallrecipes",
      name: "List Recipes",
      icon: <CgMediaLive />,
    },
    {
      path: "/addsubrecipes",
      name: "Add subRecipe",
      icon: <FaShoppingBag />,
    },
    {
      path: "/listssuballrecipes",
      name: "List subRecipes",
      icon: <CgMediaLive />,
    },

    {
      path: "/updaterecipesubrecipe",
      name: "Update Recipes",
      icon: <FaPlusCircle />,
    },
    {
      path: "/deleterecipesubrecipe",
      name: "Delete Recipes",
      icon: <MdDelete />,
    },
    {
      path: "/addbeauty",
      name: "Add Beauty",
      icon: <FaThList />,
    },
    {
      path: "/displaybeauty",
      name: "List Beauty",
      icon: <CgMediaLive />,
    },
    {
      path: "/addhaircare",
      name: "Add Haircare",
      icon: <FaThList />,
    },
    {
      path: "/displayhaircare",
      name: "List HairCare",
      icon: <CgMediaLive />,
    },
    {
      path: "/addskincare",
      name: "Add SkinCare",
      icon: <FaThList />,
    },
    {
      path: "/displayskincare",
      name: "List SkinCare",
      icon: <CgMediaLive />,
    },
    {
      path: "/addmakeup",
      name: "Add Makeup",
      icon: <FaThList />,
    },
    {
      path: "/displaymakeup",
      name: "List Makeup",
      icon: <CgMediaLive />,
    },
    {
      path: "/addwellness",
      name: "Add Wellness",
      icon: <FaThList />,
    },
    {
      path: "/displaywellness",
      name: "List Wellness",
      icon: <CgMediaLive />,
    },
    {
      path: "/addbeautytips",
      name: "Add Beautytips",
      icon: <FaThList />,
    },
    {
      path: "/displaybeautytips",
      name: "List Beautytips",
      icon: <CgMediaLive />,
    },

    {
      path: "/addblog",
      name: "Add Blog",
      icon: <FaThList />,
    },

    {
      path: "/listsallcuisines",
      name: "List Cuisines",
      icon: <FaCommentAlt />,
    },
    {
      path: "/addremedy",
      name: "Add Remedy",
      icon: <FaRegChartBar />,
    },
    {
      path: "/listsallremedy",
      name: "List Remedy",
      icon: <FaShoppingCart />,
    },
    {
      path: "/addrecipes",
      name: "Add Recipe",
      icon: <FaShoppingBag />,
    },
    {
      path: "/listsallrecipes",
      name: "List Recipes",
      icon: <CgMediaLive />,
    },
    {
      path: "/transaction",
      name: "Transaction",
      icon: <AiFillDollarCircle />,
    },
  ];
  return (
    <div className="sidebar_dash_container">
      <div
        style={{ width: isOpen ? "200px" : "50px" }}
        className="sidebar_dash_sidebar_custom"
      >
        <div className="sidebar_dash_top_section">
          <h1
            style={{ display: isOpen ? "block" : "none" }}
            className="sidebar_dash_logo"
          >
            Admin Panel
          </h1>
          <div
            style={{ marginLeft: isOpen ? "50px" : "0px" }}
            className="sidebar_dash_bars"
          >
            <FaBars onClick={toggle} />
          </div>
        </div>
        {/* {menuItem.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            className="sidebar_dash_link"
            activeclassName="active"
          >
            <div className="sidebar_dash_icon">{item.icon}</div>
            <div
              style={{ display: isOpen ? "block" : "none" }}
              className="sidebar_dash_link_text"
            >
              {item.name}
            </div>
          </NavLink>
        ))} */}
        {menuItem.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            className={({ isActive }) =>
              `sidebar_dash_link ${isActive ? "active" : ""}`
            }
          >
            <div className="sidebar_dash_icon">{item.icon}</div>
            <div
              style={{ display: isOpen ? "block" : "none" }}
              className="sidebar_dash_link_text"
            >
              {item.name}
            </div>
          </NavLink>
        ))}
      </div>

      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
